module.exports = __webpack_public_path__ + "images/default-light-big.svg";